/* eslint-disable no-unused-vars */
import React from "react";

const FormContext = React.createContext({
  values: {},
  setValue(name, value) {},
  setValues(values) {},
  registerValidation(name, validationFunction) {},
});

export default FormContext;
